$(document).ready(function() {

  let cartData = {};

  var cartPrice = document.querySelector('.cs-sidebar-cart h4.price');
  var cartCount = document.querySelector('.cs-count-items');
  var cartCountN = document.querySelector('.cs-count');
  var cartContent = document.querySelector('.cart-products');
  var mobilePopUpPriceElement = document.querySelector('.mobile-popup-price');
  var cartCheckout = document.querySelector('.cart-checkout');

  function showPromotionfreeShipping(price){

    if (price < 6000) {
      var pendingP = 6000 - price;
      var pprice = pendingP / 100;

      $('.cs-sidebar-cart .shipping-promotion').show();
      $('.cs-sidebar-cart progress').attr('value', (price / 100).toFixed(0));
      $('.cs-sidebar-cart .important.price').html('$'+pprice.toFixed(2));

      $('.grid.progress-shipping').show();
      $('.grid.progress-shipping progress').attr('value', (price / 100).toFixed(0));
      $('.grid.progress-shipping .important.price').html('$'+pprice.toFixed(2));

      //For Mobile
      //$('.cls').attr('style','display:block !important');
      $('.grid.progress-shipping-two').removeAttr('style');
      $('.grid.progress-shipping-two progress').attr('value', (price / 100).toFixed(0));
      $('.grid.progress-shipping-two .important.price').html('$'+pprice.toFixed(2));

      $('.two-business-day-shipping .value-method').html('$7.95');
      $('.two-day-free').hide();

      //For mobile
      $('.two-day-free-mobile').hide();

    }  else {

      $('.two-business-day-shipping .value-method').html('Free');

      $('.grid.progress-shipping').hide();
      $('.grid.progress-shipping .two-day-free').show();

      $('.cs-sidebar-cart .shipping-promotion').hide();
      $('.two-day-free').show();

      //For Mobile
      $('.grid.progress-shipping-two').attr('style','display:none !important');
      let windowWidth = jQuery(window).width();
      if (windowWidth > 821) {
        $('.grid.progress-shipping-two .two-day-free-mobile').hide();
        $('.two-day-free-mobile').hide();
      } else {
        $('.grid.progress-shipping-two .two-day-free-mobile').show();
        $('.two-day-free-mobile').show();
      }

    }
  }

  function emptyCart(count){

    if (count > 0) {
      $('.empty-cart').hide();
      $('.sidebar-container').show();
    }  else {
      $('.empty-cart').show();
      $('.sidebar-container').hide();


    }
  }

  function updatePartial(){
    $.ajax({
      url: '/cart.js',
      dataType: 'json'
    }).done(function(data){
      cartData =  data;
      emptyCart(parseInt(data.item_count));
      var newCount = data.item_count;
      var label = newCount > 1 ? ' Items' : ' Item';
      cartCount.innerText = "( " + newCount+ label + " )";
      cartCountN.innerText = newCount;
      var newPrice =  data.total_price / 100  ;
      cartPrice.innerText = '$'+newPrice.toFixed(2);

      var freeShippingN = parseInt(data.total_price) ;
      showPromotionfreeShipping(freeShippingN);


      var newSubtotal =  data.items_subtotal_price / 100  ;
      $('.cart__subtotal').html('$'+newPrice.toFixed(2) );

      console.log("CART ---- ", cartData);

      if(typeof(cartCheckout) != 'undefined' && cartCheckout != null){
        cartCheckout.value = "Check Out " + Shopify.formatMoney(cartData.total_price);
      }

    });
  }


  function onRebuyAddClicked (e){
    console.log("onRebuyAddClicked-------");
    e.off('click');
    loadCartcontent();
  }
  
  function loadCartcontent(){
    console.log("LOAD CART CONTENT CALLED");
    $.ajax({
      url: '/cart.js',
      dataType: 'json'
    }).done(function(data){

      cartData =  data;
      emptyCart(parseInt(data.item_count));


      var freeShippingN = parseInt(data.total_price) ;
      showPromotionfreeShipping(freeShippingN);

      var newPrice =  data.total_price / 100  ;
      cartPrice.innerText = '$'+newPrice.toFixed(2);

      var newCount = data.item_count;
      var label = newCount > 1 ? ' Items' : ' Item';
      cartCount.innerText = "( " + newCount+ label + " )";
      cartCountN.innerText = newCount;
      var products = '';

      data.items.forEach(function(element){
        var subDesc = "";
        if (element.selling_plan_allocation){
          subDesc = '<br><h5 class="subProperties">Subscription: Every ' + element.selling_plan_allocation.selling_plan.name + '</h5>'
        }
        products += '<div id="product'+element.id+'" class="product" data-id="'+element.id+'"  data-price="'+element.final_price+'">';
        products += ' <img src="'+element.featured_image.url+'alt="'+element.featured_image.alt+'">';
        products += '<section> <div class="product-header">';
        products += '     <h4 class="product-title">'+element.product_title+'</h4>';
        products +=  subDesc;
        products += '    <h5 class="product-price" >$'+ ((element.price / 100) * element.quantity).toFixed(2) +'</h5 > </div>';
        products += '  <div class="product-actions-container">';
        products += '  <div class="quantity">';
        products += '  <span class="btnqty minus">-</span>';
        products += ' <input type="text"  name="quantity-input" value="'+element.quantity+'" min="1" class="quantity-selector quantity-input" readonly/>';
        products += ' <span class="btnqty plus">+</span> </div>   <a class="remove-item" href="#" data-id="'+element.id+'">Remove Item</a>';
        products += '</div></section></div>';


      });

      cartContent.innerHTML  = products;
      
      var rebuyAddButtons = document.querySelectorAll('.rebuy-button');

      $.each(rebuyAddButtons, function () {
        var rebuyButton = this;

        if (rebuyButton && !rebuyButton.hasAttribute('listenerOnClick')) {
          rebuyButton.setAttribute('listenerOnClick', 'true');
          rebuyButton.addEventListener("click", function(e) {
            e.preventDefault();
            //Set Timeout so the Add to Cart action is completed and expedite shipping progress can be accurately updated
            setTimeout(function() {
              loadCartcontent();
            }, 2000);
          });
        }
      });

      $('.remove-item').on('click', function(e){
        e.preventDefault();
        var id = $(this).attr('data-id');
        var titleProduct = $(this).parents('.product').find('.product-title').text();
        var jqxhr = $.post('/cart/update.js', 'updates['+id+']=0');


        jqxhr.complete(function() {
          $('.cs-sidebar-cart').prepend(' <div id="product-'+id+'" class="product-deleted" data-id="'+id+'">"'+titleProduct+'" has been removed. <a class="undo" href="#">Undo</a>. </div>');
          setTimeout(function() {
            $('.cs-sidebar-cart #product-'+id).remove();
          }, 8000);

          loadCartcontent();
        });

        return false;
      });

      //
      // Mobile Add To Cart Pop Up 
      //
      $('.remove-item2').unbind().click(function(e){
        console.log('REMOVE -- MOBILE POP 2');
        e.preventDefault();
        var id = $(this).attr('data-id');        
        
        //var titleProduct = $(this).parents('.product').find('.product-title').text();
        $('.col-left-cart').hide();

        var jqxhr = $.post('/cart/update.js', 'updates['+id+']=0');

        jqxhr.complete(function() {
          //$('.remove-item2').append(' <div style="padding:5px; margin:0px;" id="product-'+id+'" class="product-deleted" data-id="'+id+'">Removed product from cart. <a class="undo" href="#">Undo</a>. </div>');
          $('<div style="padding:5px; margin:0px;" id="product-'+id+'" class="product-deleted" data-id="'+id+'">Removed product from cart. <a class="undo" href="#">Undo</a>. </div>').insertAfter( ".col-left-cart" );
          
          setTimeout(function() {
            $('.cs-sidebar-cart #product-'+id).remove();
          }, 4000);

          loadCartcontent();

        });

        return false;
      });




      //
      // END Mobile Add To Cart Pop Up App369
      //

      $('.cs-sidebar-cart .undo').on('click', function(e){
        console.log("UNDO CLICKED!!");
        e.preventDefault();
        $(this).parent().remove();
        var id = $(this).parent().attr('data-id');
                
        var jqxhr = $.post('/cart/update.js', 'updates['+id+']=1');

        jqxhr.complete(function() {

          let updateData = JSON.parse(jqxhr.responseText);
          console.log('UPDATE DATE == ',updateData);
          let updatedQuantity = updateData.items[0].quantity;
          let updatedProductPrice = Shopify.formatMoney(updateData.items[0].original_price);
          let updatedProductPriceWithout$ = updatedProductPrice.replace( /^\D|,+/g, '');

          $('.popup-quantity').val(updatedQuantity);
          $('.product-form .cs-btn-cart').attr('data-qty',updatedQuantity);
          $('.product').attr('data-price',updatedProductPriceWithout$);

          var hiddenPriceElements = document.querySelectorAll(".hidden-custom-price");
          if(typeof(hiddenPriceElements) != 'undefined' && hiddenPriceElements != null){
            [].forEach.call(hiddenPriceElements, function(priceElement) {
              priceElement.innerText= roundToTwo(updatedProductPriceWithout$);
            });
          } 
    
          if(typeof(mobilePopUpPriceElement) != 'undefined' && mobilePopUpPriceElement != null){
            mobilePopUpPriceElement.innerText = updatedProductPrice;
          }

          //START - WORK IN PROGRESS

          //END

          console.log('updatedQuantity',updatedQuantity);
          console.log('updatedProductPrice',updatedProductPrice);
          console.log('updatedProductPriceWithout$',updatedProductPriceWithout$);

          loadCartcontent();
          $('.col-left-cart').show();
        });

      });




      // add or substract quantity
      $('.quantity .btnqty').on('click', function(e){

        console.log("Quantity Selector - Clicked!!");
        e.preventDefault();
        e.stopPropagation();
        let id = $(this).parents('.product').attr('data-id');
        let qty = parseInt($(this).parents('.product').find('.quantity-input').val());
        let singlePrice = parseInt($(this).parents('.product').attr('data-price'));


        if($(this).hasClass('plus')) {

          qty++;
        }else {
          if(qty > 1) {
            qty--;
          }
        }



        qty = (isNaN(qty))?1:qty;

        $(this).parent('.quantity').find('.quantity-input').val(qty);
        var productPrice = (singlePrice / 100 ) * parseInt(qty) ;



        $(this).parents('.product').find('.product-price').html('$'+productPrice.toFixed(2));

        let jqxhr = $.post('/cart/update.js', 'updates['+id+']='+qty);
        jqxhr.complete(function() {
          updatePartial();
        });

        return false;

      });


    });


    $('.Quantity_box .btnqty').unbind().click(function(e){
      e.preventDefault();
      e.stopPropagation();
      console.log('QQQQUANTITY -- S');
      let id = $(this).parents('.products').attr('data-id');
      let qty = parseInt($(this).parents('.products').find('.quantity-input').val()); 
      let ppSinglePrice = parseFloat($('.hidden-custom-price').text().replace( /^\D|,+/g, ''));
      let singlePrice = parseInt($(this).parents('.products').attr('data-price'));
		
      console.log('singlePrice',singlePrice);
      console.log('ppSinglePrice',ppSinglePrice);

      $('.product-form .cs-btn-cart').attr('data-qty',qty );

      if($(this).hasClass('plus')) {
        qty++;
      }else {
        if(qty > 1) {
          qty--;
        }
      }



      qty = (isNaN(qty))?1:qty;

      $(this).parents('.products').find('.quantity-input').val(qty);
      var productPrice = (singlePrice / 100 ) * parseInt(qty) ;
      $(this).parents('.product').find('.product-price').html('$'+productPrice.toFixed(2));

      mobilePopUpPriceElement.innerText = '$'+(ppSinglePrice * qty).toFixed(2);

      let jqxhr = $.post('/cart/update.js', 'updates['+id+']='+qty);
      jqxhr.complete(function() {
        updatePartial();
      });

      return false;

    });
  }


  loadCartcontent();

  function addToCart(id,qty, frequency, unit_type, formData) {

    console.log("Add to Cart!!");

    let idP = parseInt(id);
    let qtyP = parseInt(qty);
    let quantity = qtyP;
	
    //To make sure that the form serialized is correct. This code patch is used due to previous poor development work - February 24, 2022
    var qtyElement = document.querySelectorAll(".quantity-desktop");
    if(typeof(qtyElement) != 'undefined' && qtyElement != null){
      [].forEach.call(qtyElement, function(element) {
        if (quantity) {
			element.value = quantity;
        }
      });
    } 

    
    console.log("qtyP = ",qtyP);
    console.log("quantity = ",quantity);
    

    var data = {
      "id": idP,
      "quantity": quantity,
      "properties": {
        "shipping_interval_frequency": frequency,
        "shipping_interval_unit_type": unit_type
      }
    }

    let windowWidth = jQuery(window).width();

    jQuery(window).bind('resize',function(){
      windowWidth = jQuery(window).width();
    });


    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(formData).serialize(),
      dataType: 'json',
      success: function() {
        if (windowWidth < 821) {
          //     window.location.href = "/cart";
        } else {
			console.log("Load Cart Content Called");
          loadCartcontent();
          showSidebar();

        }
      }

    });

    return false;
  }

  // Mobile Product Page - Add To Cart - App369
  $('.cs-btn-cart-2').click(function(e) {

    e.preventDefault();
    e.stopPropagation();
    //         let id = $(this).attr('data-id');
    let id = $('[name="id"]').val();
    let qty = $(this).attr('data-qty');
    let form = $('.product-form')[0];

    let unit_type  =  $('input[name="properties[shipping_interval_unit_type]"]').val();
    let  frequency = $('select[name="properties[shipping_interval_frequency]"]').val();
    var data = {
      "id": id,
      "quantity": qty,
    }

    let windowWidth = jQuery(window).width();



    jQuery(window).bind('resize',function(){
      windowWidth = jQuery(window).width();
    });


    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        loadCartcontent();
        //    updatePartial();       
        //      window.location.href = "/cart";

      }
    });


    return false;
  });
  
  function rebindQuantitySelector() {
    

    //Show Existing Product
    $('.col-left-cart').show();

    //rebind event add or substract quantity
    $('.product-form.product-form-product-template .Quantity_box .btnqty').on('click', function(){

      console.log("Function Called - Line 558 - Quantity Changed");

      var qty = parseInt($(this).parents('.Quantity_box').find('#quantityInput').val());

      if($(this).hasClass('plus')) {
        qty++;
      }else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty)) ? 1 : qty;
      $('.product-form .cs-btn-cart').attr('data-qty',qty );
      var label = qty > 1 ? ' Items' : ' Item';
      $('.product-form .qty-item').html("("+qty+ label+")");
      var price = $('.product-form .custom-price').attr('data-price');
      var newPrice =  ( parseInt(price) / 100 ) * qty ;
      $('.product-form .custom-price').html('$'+newPrice.toFixed(2));
      $(this).parents('.Quantity_box').find('#quantityInput').val(qty);

      if($('.bsub-widget').length){
        const priceElement = document.querySelector('#ProductPrice-product-template');      
        const priceElements = document.querySelectorAll('#ProductPrice-product-template');
        const price = priceElement.innerText;
        window.handleBoldSubscriptionsPriceElements(priceElement,priceElements,price);
      }

    });
    
  }

  // END of Mobile Product Page - Add To Cart 


  $('.cs-add-to-cart').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    let id = $(this).attr('data-id');

    var data = {
      "id": id,
      "quantity": 1,
    }

    let windowWidth = jQuery(window).width();



    jQuery(window).bind('resize',function(){
      windowWidth = jQuery(window).width();
    });


    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        if (windowWidth < 821) {

          //collection page
          //                            loadCartcontent();
          //    updatePartial();

         // window.location.href = "/cart";

        } else {

          loadCartcontent();
          showSidebar();


        }

      }
    });


    return false;
  });

  $('.cart-products').html('');

  // show sidebar and overlay
  function showSidebar() {
    sidebar.css('margin-right', '0');

    overlay.show(0, function() {
      overlay.fadeTo('500', 0.5);
    });
  }

  // hide sidebar and overlay
  function hideSidebar() {

    sidebar.css('margin-right', sidebar.width() * -1 + 'px');

    //rebind event add or substract quantity
	rebindQuantitySelector();
    
    overlay.fadeTo('500', 0, function() {
      overlay.hide();
    });
  }

  // selectors
  var sidebar = $('[data-sidebar]');
  var button = $('[data-sidebar-button]');
  var overlay = $('[data-sidebar-overlay]');

  // add height to content area
  overlay.parent().css('min-height', 'inherit');

  // hide sidebar on load
  sidebar.css('margin-right', sidebar.width() * -1 + 'px');

  sidebar.show(0, function() {
    sidebar.css('transition', 'all 0.5s ease');
  });

  // toggle sidebar on click
  $('.site-header__cart').click(function(e) {
    let windowWidth = jQuery(window).width();


    jQuery(window).bind('resize',function(){
      windowWidth = jQuery(window).width();
    });




    if (windowWidth < 821) {
      //window.location.href = "/cart";
    } else {
      e.preventDefault();
      if (overlay.is(':visible')) {
        hideSidebar();
      } else {
        showSidebar();
        loadCartcontent();
      }

      return false;
    }



  });

  // hide sidebar on overlay click
  overlay.click(function() {
    hideSidebar();
  });

  $('.close-sidebar').on('click',function(e){

    e.preventDefault();
    // hide sidebar on overlay click

    hideSidebar();
  });


  $('#close-sidebar-cart').on('click',function(e){

    e.preventDefault();
    // hide sidebar on overlay click

    hideSidebar();
  });


  /// PRODUCT PAGE
  $('.product-form.product-form-product-template').submit(function( event ) {
    event.preventDefault();
    return false;
  });


  // add or substract quantity
  $('.product-form.product-form-product-template .Quantity_box .btnqty').on('click', function(){

    console.log("Function Called - Line 558 - Quantity Changed");

    var qty = parseInt($(this).parents('.Quantity_box').find('#quantityInput').val());

    if($(this).hasClass('plus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty)) ? 1 : qty;
    $('.product-form .cs-btn-cart').attr('data-qty',qty );
    var label = qty > 1 ? ' Items' : ' Item';
    $('.product-form .qty-item').html("("+qty+ label+")");
    var price = $('.product-form .custom-price').attr('data-price');
    var newPrice =  ( parseInt(price) / 100 ) * qty ;
    $('.product-form .custom-price').html('$'+newPrice.toFixed(2));
    $(this).parents('.Quantity_box').find('#quantityInput').val(qty);

    if($('.bsub-widget').length){
      const priceElement = document.querySelector('#ProductPrice-product-template');      
      const priceElements = document.querySelectorAll('#ProductPrice-product-template');
      const price = priceElement.innerText;
      window.handleBoldSubscriptionsPriceElements(priceElement,priceElements,price);
    }

  });

  $('.product-form.product-form-product-template .cs-btn-cart').click(function(e) {

    e.preventDefault();
    e.stopPropagation();
    let id = $('[name="id"]').val();
    let qty = $(this).attr('data-qty');
    let form = $('.product-form')[0];

    let unit_type  =  $('input[name="properties[shipping_interval_unit_type]"]').val();
    let  frequency = $('select[name="properties[shipping_interval_frequency]"]').val();
    
    console.log("Form ATC Clicked with QTY = ",qty);

    addToCart(parseInt(id),parseInt(qty), frequency,  unit_type, form);

  });
  
  
  // Assign function to onclick property of upsell checkbox

  const closePopUpActionElements = document.querySelectorAll(".closePopUpAction")
  for (const closePopUpElement of closePopUpActionElements) {
    closePopUpElement.addEventListener('click', function(event) {
      //rebind event add or substract quantity
      rebindQuantitySelector();
      
      //Reset with default price and qty
      $('.quantity-input').val('1');
      let ppSinglePrice = $('.hidden-custom-price').text().replace( /^\D|,+/g, '');
      const priceElement = document.querySelector('#ProductPrice-product-template');      
      let priceWithout$ = priceElement.innerText.replace( /^\D|,+/g, '');

      console.log("=======priceElement=======",priceElement.innerText);
      console.log("=======ppSinglePrice=======",ppSinglePrice);
      console.log("=======priceWithout=======",priceWithout$);
      priceElement.innerText = '$'+priceWithout$;

      mobilePopUpPriceElement.innerText = '$'+ppSinglePrice;


      if($('.bsub-widget').length){
        const priceElement = document.querySelector('#ProductPrice-product-template');      
        const priceElements = document.querySelectorAll('#ProductPrice-product-template');
        window.handleBoldSubscriptionsPriceElements(priceElement,priceElements,priceWithout$);
      }

    });
  }


});